import React, { Component } from 'react'
import { connect } from 'react-redux'
import VaultResLookupMaskedSample from '../samples/VaultResLookupMaskedSample'
import { makeVaultResLookupMasked } from '../../../actions/vaultAction'
import { updateOrderId } from '../../../actions/commonActions'
import { _VAULT } from '../../../actions/types'

const OBJECT = [  "resLookupMasked", "resLookupMasked", "resLookupMasked"]
const METHODS = { 
    SetEncTrack2:[  ".SetEncTrack2(enc_track2);", ".SetEncTrack2(enc_track2);", "'enc_track2'=>$enc_track2"],
    SetDeviceType:[  ".SetDeviceType;", ".SetDeviceType;", "'device_type'=>$device_type"], 
    SetCusId: [  ".SetCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    SetAvsCheck: [  ".SetAvsInfo(avsCheck);", ".setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    SetEmail: [  ".SetEmail(email);", ".setEmail(email);", "'email'=>$email"],
    SetPhone: [  ".SetPhone(phone);", ".setPhone(phone);", "'phone'=>$phone"],
    SetNote: [  ".SetNote(note);", ".setNote(note);", "'note'=>$note"],
    SetDataKeyFormat: [  ".SetDataKeyFormat(data_key_format);", ".SetDataKeyFormat(data_key_format);", "'data_key_format'=>$data_key_format"],
    SetDataKey: [  ".setData(data_key);", ".setData(data_key);", "'data_key'=>$data_key"],
    CreditCardNumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    ExpiryDay: [  ".setExpdate(expiry_date);", ".setExpdate(expiry_date);", "'expdate'=>$expiry_date"],
    SetDuration: [  ".SetDuration(duration);", ".SetDuration(duration);", "'duration'=>$duration"],
    CreditCardCumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    SetCryptType: [  ".SetCryptType(crypt);", ".setCryptType(crypt);", "'crypt_type'=>$crypt"],    
    setCotInfo: [  ".SetCofInfo(cof);", ".setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    SetIssueId: [  `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{$cof->setIssuerId("VALUE_FOR_ISSUER_ID");}`],
}
export class VaultLookUpMask extends Component {
    state = {
        showError:false,
        showSuccess:false,
        justClicked:false,
      };
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}>
                    <strong>Error!</strong><br />
                    Please check your parameters within Vault ResLookupMasked.
                </div>
            );
        }
        // else if(this.state.showSuccess) {
        //     return (
        //         <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}>
        //             <strong>Vault ResLookupMasked Accepted!</strong><br />
        //             The returned receipt has been inserted to the JSON on the right, you can make another Vault Request now.
        //         </div>
        //     );
        // }
    }

    //TODO fix this
    componentDidUpdate() {
        const { reslookupmaskSuccess,ResLookUpMaskResponse,loading } = this.props; 
        if(ResLookUpMaskResponse!=="No request has been made."  && this.state.justClicked){
            if(reslookupmaskSuccess){
                    this.setState({ showError: false,showSuccess: true,justClicked:false });  
                }
            else {
                if(!loading){
                    this.setState({  showError: true, showSuccess: false,justClicked:false });
                }
            }
        }
    }
    //TODO fix this
    async onMakeResLookUpMask() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _VAULT, orderId: newOrderId });
        const { storeId, apiToken, order_id, pan, expdate, amount } = this.props;
        const lookupmaskedRequest = { storeId, apiToken, order_id, pan, expdate, amount };
        this.props.makeVaultResLookupMasked(lookupmaskedRequest);
        this.setState({justClicked:true});
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample ResLookupMasked</h3>
                <VaultResLookupMaskedSample/>
                <div className="requestButton" onClick={() => this.onMakeResLookUpMask()}>
                    ResLookupMasked Request
                </div> 
                {this.renderMessage()}
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }

    renderDocument() { 
        const { progLangId } = this.props;
        return (
            <div className="stepPageContainer">
            <h3 className="stepPageTitle">Vault Lookup Masked – ResLookupMasked</h3>
            <p><b>Vault Lookup Masked transaction object definition</b></p>   
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>ResLookupMasked resLookupMasked = new ResLookupMasked();
                            </code>
                        case 1:
                            return <code>ResLookupMasked resLookupMasked = new ResLookupMasked();

                            </code>
                        case 2:
                            return <code>
                                {`$txnArray = array(‘type’=>’res_lookup_masked', …);`}<br/>
                                {`$mpgTxn = new mpgTransaction($txnArray);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
            <p><b>HttpsPostRequest object for Vault Lookup Masked transaction</b></p> 
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();
                            </code>
                        case 1:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();

                            </code>
                        case 2:
                            return <code>
                                {`$mpgRequest = new mpgRequest($mpgTxn);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
                   {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>mpgReq.SetTransaction(resLookupMasked);</code>
                        case 1:
                            return <code>mpgReq.setTransaction(resLookupMasked);</code>
                        case 2:
                            return <code>
                                {`$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);`}
                                </code>
                        default:
                            return null
                        }
                    })()}
        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Lookup Masked transaction request fields – Required</h3>
        <p>For a full description of mandatory and optional values, see Appendix A Definition of Request Fields.</p>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>data key</td>
                    <td>String<br/>max 20-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDataKey[progLangId]}</code></td>
                </tr>
                </tbody>
            </table>
            <p><b>Vault response fields</b></p>
            <p>For a list and explanation of (Receipt object) response fields that are available after sending this Vault
                transaction, see Definitions of Response Fields.
            </p>
        </div>
        )
    }
}


const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { reslookupmaskSuccess,ResLookUpMaskResponse,loading } = state.vault.main;
    const { storeId, apiToken, order_id, pan, expdate, amount} = state.vault.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, amount,loading, progLangId: state.common.progLangList.selection,reslookupmaskSuccess,ResLookUpMaskResponse };
  }

export default connect(mapStateToProps,{updateOrderId,makeVaultResLookupMasked})(VaultLookUpMask) 

